import React, { useEffect, useState } from "react";
import { Switch, Select } from "antd";
import axios from "axios";

import InitialsAvatar from "../../../../shared/components/InitialsAvatar";
import Barra from "../../components/BarraAreaAluno/BarraAreaAluno";
import FotoAluno from "../../components/FotoAluno/FotoAluno";
import TabelaAluno from "../../components/TabelaAluno/TabelaAluno";
import TabelaAlunoMobile from "../../components/TabelaAluno/TabelaAluno2";

import "../../../../scss/_areaAluno.scss";
import styles from "./Inicio.module.scss";

const { Option } = Select;

const Inicio = () => {
    const [numeroAluno, setNumeroAluno] = useState("");
    const [alunoInfo, setAlunoInfo] = useState();
    const [dadosAluno, setDadosAluno] = useState([]);
    const [turmasAtivas, setTurmasAtivas] = useState(true);
    const [turmas, setTurmas] = useState([]);
    const [edicoes, setEdicoes] = useState([]);
    const [edicaoSelecionada, setEdicaoSelecionada] = useState();

    const columns = [
        { header: "Escolas", key: "escola" },
        { header: "Ano", key: "ano" },
        { header: "Nivel", key: "nivel" },
        { header: "Turma", key: "turma" }
    ];

    const fetchEdicoes = async () => {
        try {
            const response = await axios({
                method: "get",
                url: `/api/gestao-turmas/lista-edicoes`
            });

            setEdicoes(response.data);
        } catch (error) {
            console.error("Não foi possível carregar as edicoes");
        }
    };

    const fetchInfoAluno = async () => {
        try {
            const response = await axios({
                method: "get",
                url: `/api/area-aluno/listar`
            });

            setDadosAluno(response.data);
        } catch (error) {
            console.error("Não foi possível carregar as informações do aluno");
        }
    };

    const fetchNomeAluno = async () => {
        const url = `/api/area-aluno/nomeAluno`;

        try {
            const response = await axios.get(url);

            setAlunoInfo(response.data);
            localStorage.setItem("nome", response.data.nome_completo);
            setNumeroAluno(response.data.nr_aluno);

            localStorage.setItem("nome", response.data.nome_completo);
        } catch (error) {
            console.error("Error ao fazer a requisição GET", error);
        }
    };

    useEffect(() => {
        var turmasFiltras = dadosAluno.filter(x => x.ativa == turmasAtivas);

        if (edicaoSelecionada) {
            var turmasFiltras = turmasFiltras.filter(x => x.ano == edicaoSelecionada);
        }
        setTurmas(turmasFiltras);
    }, [dadosAluno, turmasAtivas, edicaoSelecionada]);

    useEffect(() => {
        fetchInfoAluno();
        fetchNomeAluno();
        fetchEdicoes();
    }, []);

    return (
        <>
            <div className={styles.detalheAluno}>
                <div className={styles.titulo}>
                    <h1> ÁREA DO ALUNO</h1>
                </div>

                {alunoInfo && <Barra nome={alunoInfo.nome_completo} />}

                {alunoInfo && (
                    <div className="mobile-only">
                        <div className={styles.info}>
                            <div className={styles.fotoMobile}>
                                {alunoInfo.foto ? (
                                    <img src={alunoInfo.foto} alt="foto" />
                                ) : (
                                    <div className={styles.foto2}>
                                        {alunoInfo.nome_completo !== "" && <InitialsAvatar name={alunoInfo.nome_completo} />}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className={`${styles.info} ${styles.infoDados}`}>
                            <div>
                                <div className={styles.nome2}>
                                    <span>{alunoInfo.nome_completo}</span>
                                </div>
                                <div className={styles.numero2}>
                                    <span>{numeroAluno}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className={styles.info}>
                    {alunoInfo && (
                        <div className="desktop-only">
                            <FotoAluno foto={alunoInfo.foto} nome={alunoInfo.nome_completo} numero={numeroAluno} />
                        </div>
                    )}

                    <div className={`desktop-only ${styles.tabela}`}>
                        <div className={styles.filtrosTurmas}>
                            <Select
                                value={edicaoSelecionada}
                                onChange={setEdicaoSelecionada}
                                placeholder="Edição"
                                disabled={!edicoes.length}
                                allowClear={true}
                                className={styles.filtroEdicao}
                            >
                                {edicoes.map(edicao => (
                                    <Option value={edicao.nome} key={edicao.id}>
                                        {edicao.nome}
                                    </Option>
                                ))}
                            </Select>

                            <Switch
                                checkedChildren={"ativas"}
                                unCheckedChildren={"inativas"}
                                defaultChecked={turmasAtivas}
                                onChange={setTurmasAtivas}
                            />
                        </div>
                        {<TabelaAluno columns={columns} data={turmas} />}
                    </div>

                    <div className={`mobile-only ${styles.tabela}`}>{turmas.length > 0 && <TabelaAlunoMobile columns={columns} data={turmas} />}</div>
                </div>
            </div>
        </>
    );
};

export default Inicio;
